import { render } from "./ActivityLogItem.vue?vue&type=template&id=221b5250"
import script from "./ActivityLogItem.vue?vue&type=script&lang=js"
export * from "./ActivityLogItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__